module.exports = "<wor-navbar></wor-navbar>\n<ui-view class=\"view\"></ui-view>";